'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';

const FollowUpList = createPage(
	() => import('@/features/for-you/components/FollowUp'),
);

export default function FollowUpPage() {
	return <FollowUpList />;
}
